export const ACCOUNTANT_BIO_TRUNCATE_LENGTH = 180;
